import React from 'react';
import { Account } from 'types/account';
import { CandidateStories, PromptGroup } from 'types/candidateStories';
import {
  CandidateStoryDocsForm,
  CandidateStoryPromptTextForm,
  CandidateStoryPromptFileForm,
} from '../Common';
import {
  CandidateStoryHeader,
  CandidateStoryItemTitle,
  TranslatedParagraph,
} from '../../../../Common';
import GeneralInformationTextForm from './GeneralInformationTextForm';
import { CANS_STEP_PROVIDE } from '../../../../../../../../../../constants';
import { settingIsEnabled } from '../../../../../../../../../../lib/helpers';

type Props = {
  account: Account;
  remove: (i: number, field: string) => void;
  selectedItems: number;
  candidateStories: CandidateStories;
  promptGroup?: PromptGroup;
};

const DOCS = 'docs';
const TEXT = 'text';

const GeneralInformationForm = ({
  account,
  candidateStories,
  remove,
  selectedItems,
  promptGroup,
}: Props) => {
  const setting = account.candidateStoriesGeneralInfo;
  const docsEnabled = settingIsEnabled(setting, {
    nullish: true,
    keys: [DOCS],
  });
  const textEnabled = settingIsEnabled(setting, {
    nullish: true,
    keys: [TEXT],
  });

  if (!candidateStories.general) {
    candidateStories.general = { documents: [] };
  }

  const removeDocuments = (i: number) => {
    remove(i, 'candidateStories.general.documents');
  };

  const hasPromptGroup = promptGroup !== undefined;

  if (hasPromptGroup) {
    if (!candidateStories.promptGroup) {
      candidateStories.promptGroup = {};
    }
    if (!candidateStories.promptGroup.general) {
      candidateStories.promptGroup.general = {};
    }
  }

  return (
    <div>
      <CandidateStoryHeader
        step={CANS_STEP_PROVIDE}
        provide_step={1}
        provide_total={selectedItems}
      />
      <div className='form-question-wrapper'>
        <h4 className='form-question'>
          <CandidateStoryItemTitle />
        </h4>
        <TranslatedParagraph
          value='components.Report.CandidateStories.Modal.GeneralInformation.description'
          interpolationValues={{
            company: account.name,
          }}
        />
      </div>
      <div>
        {hasPromptGroup ? (
          <div data-testid='candidate-stories-prompt-forms'>
            <CandidateStoryPromptTextForm
              promptGroup={promptGroup}
              disabled={!textEnabled}
              account={account}
            />
            <CandidateStoryPromptFileForm
              promptGroup={promptGroup}
              disabled={!docsEnabled}
              promptDocuments={candidateStories.promptGroup?.general}
              remove={remove}
            />
          </div>
        ) : (
          <div data-testid='candidate-stories-legacy-forms'>
            <GeneralInformationTextForm
              company={account.name}
              disabled={!textEnabled}
              field='candidateStories.content.general'
              data-testid='candidate-stories-general-information-text-box'
            />
            <CandidateStoryDocsForm
              documents={candidateStories.general.documents}
              disabled={!docsEnabled}
              field='candidateStories.general.documents'
              remove={removeDocuments}
              data-testid='candidate-stories-general-information-docs-form'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralInformationForm;
